import * as _ from 'lodash';
import { SorterColumnDataType } from '../../../../ng2/shared/constants/sorter-column-data-type.constant';

export class SorterColInput {
  static $inject = ['SorterColInputTypes'];

  constructor(private SorterColInputTypes) {}

  // Methods

  getInputType = (type, dataType) => {
    if (type) {
      if (!this.SorterColInputTypes[type.toUpperCase()]) {
        throw new Error('Invalid inputType');
      }
      return type;
    } else {
      switch (dataType) {
        case SorterColumnDataType.STRING:
          return this.SorterColInputTypes.TEXT;
        case SorterColumnDataType.BOOLEAN_YES_NO:
          return this.SorterColInputTypes.CHECKBOX;
        case SorterColumnDataType.NUMERIC:
          return this.SorterColInputTypes.TEXT;
        case SorterColumnDataType.ENUM:
          return this.SorterColInputTypes.DROPDOWN;
        case SorterColumnDataType.ARRAY:
          return this.SorterColInputTypes.DROPDOWN;
        case SorterColumnDataType.USER_MINI:
          return this.SorterColInputTypes.USER_PICKER;
        default:
          throw new Error(`Cannot find SorterColInputType for dataType ${dataType}`);
      }
    }
  };

  getItems = (items, dataTypeOptions) => {
    if (items) {
      return items;
    } else if (dataTypeOptions) {
      if (dataTypeOptions.canBeNull) {
        dataTypeOptions.values.push(null);
        return _.uniq(dataTypeOptions.values);
      }
      return dataTypeOptions.values;
    }
    return undefined;
  };
}

angular.module('nv.components.sorter-col-input').service('SorterColInput', SorterColInput);
